import { skipToken, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  DashboardSummaryParams,
  getDashboardTransactionsDynamicSummary,
} from 'config/requests/dashboard';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TransactionsDynamicSummary } from 'types/embedded/dashboard';
import { ErrorData } from 'types/embedded/error';

export function useGetDashboardTransactionsDynamicSummary(params: DashboardSummaryParams | null): {
  isLoading: boolean;
  summary?: TransactionsDynamicSummary;
  error?: string;
} {
  const translate = useTypedTranslate();

  const {
    data: summary,
    isLoading,
    error,
  } = useQuery<TransactionsDynamicSummary, AxiosError<ErrorData>>({
    queryKey: ['dashboard/executed_transactions_amount_by_steps', params],
    queryFn: params ? () => getDashboardTransactionsDynamicSummary(params) : skipToken,
  });

  const errorMessage = error
    ? error.response?.data?.errors?.[0].title || translate('app.common.serverError')
    : undefined;

  return { summary, isLoading, error: errorMessage };
}
